import { render, staticRenderFns } from "./bookmark-management.vue?vue&type=template&id=3340a3bc&scoped=true"
import script from "./bookmark-management.vue?vue&type=script&lang=js"
export * from "./bookmark-management.vue?vue&type=script&lang=js"
import style0 from "./bookmark-management.vue?vue&type=style&index=0&id=3340a3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3340a3bc",
  null
  
)

export default component.exports